const useRolStore = defineStore("rol", () => {
  // state
  const rol = ref({
    nombre: null,
    id: null,
    permisos: [],
  });

  const roles = ref([]);

  // getters
  const draft = computed(() => {
    return clone(rol.value);
  });

  const getRols = () => {
    return roles.value.map((val) => ({
      label: val.nombre,
      value: val.id,
      id: val.id,
    }));
  };

  // mutations

  const format_rol = (role) => {
    return {
      nombre: role.nombre,
      id: role.id,
      permisos: role.permisos.map((val) => {
        const actions = JSON.parse(val.pivot.actions);
        return {
          module: val.nombre,
          read: actions.find((va) => va == "read") ? true : false,
          write: actions.find((va) => va == "write") ? true : false,
          update: actions.find((va) => va == "update") ? true : false,
          delete: actions.find((va) => va == "delete") ? true : false,
        };
      }),
      permissions: role.permisos,
    };
  };

  const clearRol = () => {
    rol.value = {
      nombre: null,
      id: null,
      permisos: [],
    };
  };

  const setRol = (role) => {
    rol.value = role;
  };

  const capturarRol = (id_rol) => {
    rol.value = roles.value.find((role) => role.id == id_rol);
  };

  const setRoles = (data) => {
    roles.value = [];
    data.forEach((role) => roles.value.push(format_rol(role)));
  };

  const pushRol = (role) => {
    if (roles.value.find((rol) => rol.id == role.id)) {
      roles.value.forEach((rol, i) => {
        if (rol.id == role.id) roles.value[i] = format_rol(role);
      });
    } else {
      roles.value.push(format_rol(role));
    }
  };

  const putRol = (rol_id) => {
    var i = roles.value.findIndex((rol) => rol.id == rol_id);
    if (i) roles.value.splice(i, 1);
  };

  const updateRol = (data) => {
    let i = roles.value.findIndex((val) => val.id == data.id);
    if (i != -1) {
      roles.value[i] = data;

      if (rol.value.id == data.id) rol.value = data;
    }
  };

  // actions

  const fetch = (rol_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/roles/${rol_id}/fetch-data`)
        .then(({ data }) => {
          setRol(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const listarRoles = () => {
    return new Promise((resolve, reject) => {
      axios
        .get("/api/roles/list-select")
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => {
          reject(e);
        });
    });
  };

  const fetchData = (data) => {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/roles/fetch-data`, data)
        .then(({ data }) => {
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  const guardarRol = (datos) => {
    return new Promise((resolve, reject) => {
      if (datos.id) {
        axios
          .put(`/api/roles/${datos.id}`, datos)
          .then(({ data }) => {
            resolve(data);
          })
          .catch((e) => reject(e));
      } else {
        axios
          .post("/api/roles", datos)
          .then(({ data }) => {
            if (data.result) pushRol(data.rol);
            resolve(data);
          })
          .catch((e) => reject(e));
      }
    });
  };

  const eliminar = (rol_id) => {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/roles/delete/${rol_id}`)
        .then(({ data }) => {
          resolve(data);
          putRol(rol_id);
        })
        .catch((e) => reject(e));
    });
  };

  const getRol = (rol_id) => {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/roles/${rol_id}/get`)
        .then(({ data }) => {
          pushRol(data);
          resolve(data);
        })
        .catch((e) => reject(e));
    });
  };

  return {
    rol,
    roles,
    draft,
    getRols,
    clearRol,
    setRol,
    capturarRol,
    setRoles,
    pushRol,
    putRol,
    updateRol,
    fetch,
    listarRoles,
    fetchData,
    guardarRol,
    eliminar,
    getRol,
  };
});

export default useRolStore;
